import PropTypes from 'prop-types';

export const singleAssignmentPropTypes = PropTypes.shape({
  assignmentCode: PropTypes.string.isRequired,
  assignmentType: PropTypes.string.isRequired,
  privileges: PropTypes.arrayOf(PropTypes.string).isRequired,
});

export const userClientPropTypes = PropTypes.shape({
  clientId: PropTypes.number.isRequired,
  canEdit: PropTypes.bool,
  name: PropTypes.string.isRequired,
  reviewerSso: PropTypes.string,
  role: PropTypes.string,
  roleId: PropTypes.string,
  assignments: PropTypes.arrayOf(singleAssignmentPropTypes),
  expirationDate: PropTypes.string,
  expirationSso: PropTypes.string,
});

export const userClientListPropTypes = PropTypes.arrayOf(userClientPropTypes);
